// Copyright (c) 2017 Deere & Company

export const getLinks = (links, type) =>
    links.filter(link => link.location === type);



// WEBPACK FOOTER //
// ./src/shared/services/get-links.js